<template lang="pug">
    div(
        role="dialog",
        class="_pane _con",
        :class="{ show }",
        :style="{ width: width, height: height }",
        :dir="direction",
        @touchstart="touchstart",
        @touchend="touchend",
        v-show="raf || show")
        slot
</template>

<script>
    export default {
        name: 'ib-pane',

        props: {
            width: String,
            height: String,
            autoclose: Boolean,
            trigger: Object
        },

        data() {
            return {
                raf: 0,
                show: false,
                vert: false,
                x: 0,
                lx: 0
            };
        },

        computed: {
            direction() {
                const app = this.$root.__app;
                return app ? app.direction : 'ltr';
            }
        },

        mounted() {
            this.vert = this.$el.classList.contains('top') || this.$el.classList.contains('bottom');
        },

        destroyed() {
            this.autoclose_(false);
        },

        watch: {
            autoclose(autoclose) {
                if (this.show) {
                    this.autoclose_(autoclose);
                }
            }
        },

        methods: {
            open() {
                if (!this.show) {
                    const fg = this.$el;
                    const focus = fg.querySelector('[autofocus]');
                    this.$nextTick(() => {
                        fg.scrollTop = 0;
                        if (focus) {
                            focus.focus();
                        }
                    });
                    if (this.raf) {
                        cancelAnimationFrame(this.raf);
                    }
                    this.raf = requestAnimationFrame(() => {
                        this.raf = requestAnimationFrame(() => {
                            this.raf = 0;
                            this.show = true;
                        });
                    });
                    this.autoclose_(this.autoclose);
                    this.$emit('open');
                }
            },

            close() {
                if (this.show) {
                    this.show = false;
                    this.autoclose_(false);
                    this.$emit('close');
                }
                if (this.raf) {
                    cancelAnimationFrame(this.raf);
                }
                this.raf = setTimeout(() => {
                    this.raf = 0;
                }, 500);
            },

            toggle() {
                if (this.show) {
                    this.close();
                } else {
                    this.open();
                }
            },


            /** Touch events */

            touchstart(e) {
                this.$el.addEventListener('touchmove', this.touchmove);
                this.$el.classList.add('_grab');
                this.x = this.vert ? e.touches[0].clientY : e.touches[0].clientX;
            },

            touchend(e) {
                this.$el.removeEventListener('touchmove', this.touchmove);
                this.$el.classList.remove('_grab');
            },

            touchmove(e) {
/*
                let x = this.vert ? e.touches[0].clientY : e.touches[0].clientX;
                x -= this.x;
                this.lx = x;
                this.$util.transform();
*/
            },


            /** Set autoclose state */

            autoclose_(autoclose) {
                if (autoclose) {
                    document.addEventListener('mousedown', this.dismiss, true);
                    document.addEventListener('touchstart', this.dismiss, true);
                } else {
                    document.removeEventListener('mousedown', this.dismiss, true);
                    document.removeEventListener('touchstart', this.dismiss, true);
                }
            },

            dismiss(e) {
                if (!this.$util.isInside(this.$el, e.clientX, e.clientY) && e.target !== this.$el && !this.$util.isChild(e.target, this.$el)) {
                    const trigger = this.trigger ? (this.trigger.$el || this.trigger) : null;
                    if (!trigger || (e.target !== trigger && !this.$util.isChild(e.target, trigger))) {
                        this.close();
                    }
                }
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._pane {
        position: fixed;
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        opacity: 0;
        overflow: hidden;
        will-change: opacity;
        z-index: @z-modeless-high;
        .shadow-high();
        -webkit-transition: opacity .4s ease-out, -webkit-transform .4s ease-out;
                transition: opacity .4s ease-out, transform .4s ease-out;
        &,
        .bg {
            background: @bg-modeless;
        }

        &._grab {
            -webkit-transition: none;
            transition: none;
        }
    }

    ._pane.left,
    ._pane.start,
    ._pane.end[dir=rtl] {
        left: 0;
        right: auto;
        -webkit-transform: translate(-100%,0);
                transform: translate(-100%,0);
    }
    ._pane.right,
    ._pane.end,
    ._pane.start[dir=rtl] {
        left: auto;
        right: 0;
        -webkit-transform: translate(100%,0);
                transform: translate(100%,0);
    }
    ._pane.top {
        bottom: auto;
        -webkit-transform: translate(0,-100%);
                transform: translate(0,-100%);
    }
    ._pane.bottom {
        top: auto;
        -webkit-transform: translate(0,100%);
                transform: translate(0,100%);
    }
    ._pane.show {
        -webkit-transform: translate(0,0) !important;
                transform: translate(0,0) !important;
        opacity: 1;
    }
</style>
